import styled from 'styled-components';

export const NewMessagesIndicatorContainer = styled.button`
  position: fixed;
  bottom: 14rem;
  right: 2rem;
  background-color: #d1d1d1;
  color: #525f7f;
  padding: 10px;
  border-radius: 100%;
  border: none;
  cursor: pointer;
  display: flex;
  z-index: 1000;

  & > span {
    position: absolute;
    top: -0.7rem;
    right: 1.5rem;
    background-color: ${(props) => props.color};

    color: #fff;
    display: flex;
    border-radius: 100%;
    padding: 4px;
    align-content: center;
    justify-content: center;
    align-items: center;
    font-size: 0.79rem;
    border: 0.5px solid #dbdbdb;
    width: 1.7rem;
    height: 1.7rem;
  }
`;
